{
  "pending": "pendiente"
}
